import { useEffect, useState } from 'react'
import qrImage from './QRimage.png'
import tmallImage from './TmallImage.png'

/**
 * 라벨 로고 이미지(1.0 `glTemplate/QRimage.png`·`TmallImage.png` 사본).
 *
 * qz-tray 는 받은 HTML 을 브라우저 밖에서 그려 상대 경로를 풀지 못한다. 1.0 은 티몰 이미지를 data URL 로 바꿔 넣었다 —
 * 2.0 은 두 이미지 모두 data URL 로 바꾸고, 바꾸기 전·실패 시에는 절대 URL 을 쓴다.
 */
const toAbsoluteUrl = (src: string): string => {
  try {
    return new URL(src, window.location.href).href
  } catch {
    return src
  }
}

const toDataUrl = async (src: string): Promise<string> => {
  const blob = await (await fetch(src)).blob()
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => (typeof reader.result === 'string' ? resolve(reader.result) : reject(new Error('data url')))
    reader.onerror = () => reject(reader.error ?? new Error('data url'))
    reader.readAsDataURL(blob)
  })
}

export interface LabelImages {
  qr: string
  tmall: string
}

export const useLabelImages = (): LabelImages => {
  const [images, setImages] = useState<LabelImages>(() => ({ qr: toAbsoluteUrl(qrImage), tmall: toAbsoluteUrl(tmallImage) }))
  useEffect(() => {
    let alive = true
    if (typeof fetch !== 'function' || typeof FileReader === 'undefined') return undefined
    Promise.all([toDataUrl(qrImage), toDataUrl(tmallImage)])
      .then(([qr, tmall]) => {
        if (alive) setImages({ qr, tmall })
      })
      .catch(() => undefined)
    return () => {
      alive = false
    }
  }, [])
  return images
}
